<template>
  <div>
    <b-navbar toggleable="lg" fixed="top" type="light" variant="light">
      <b-navbar-brand href="#"><img src="../assets/titlelogo.png" height="30"></b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item class="text-center">小高の街案内アプリ</b-nav-item>
          <b-nav-item to="/">TOP</b-nav-item>
          <b-nav-item  v-if="authed" to="/place/add">場所を追加</b-nav-item> <!--この行を追加-->
          <b-nav-item  v-if="authed" to="/signout">サインアウト</b-nav-item>
          <b-nav-item  v-else to="/signin">サインイン</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <b-navbar fixed="bottom" type="light" variant="light" style="padding: 0;">
      <b-navbar-nav fill justified style="width: 100%" class="h3">
          <b-nav-item to="/about" exact-active-class="text-info"><font-awesome-icon icon="id-card" /><h6>About</h6></b-nav-item>
          <b-nav-item to="/" exact-active-class="text-info"><font-awesome-icon icon="home" /><h6>一覧</h6></b-nav-item>
          <b-nav-item to="/map" exact-active-class="text-info"><font-awesome-icon icon="map" /><h6>地図</h6></b-nav-item>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>
import { auth } from '@/firebase/firebase'
export default {
  computed: {
    authed : function() {
      auth.currentUser
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue